import React from "react";
import loadable from "@loadable/component";
import { Navigate } from "react-router";
//antd에서 아이콘 가져오기
import {
  UserOutlined,
  MessageOutlined,
  CustomerServiceOutlined,
  BookOutlined,
  BellOutlined,
  CarOutlined
} from "@ant-design/icons";

//로그인 없이 이용가능 페이지
export const publicRoutes = [
  //첫시작 로그인으로 설정 => ('/' 해당 url 사용 안함)
  {
    exact: true,
    path: "/",
    component: () => {
      if (localStorage.getItem("token")) {
        return <Navigate to="/dashboard" />
      } else {
        return <Navigate to="/login" />
      }
    },
  },
  {
    exact: true,
    path: "/login",
    component: loadable(() => import("../pages/auth/Login")),
  },
];

//로그인 시에만 이용가능 페이지
export const privateRoutes = [
  {
    exact: true,
    path: "/dashboard",
    sidebar: {
      icon: <img src="/assets/icon/Dashboard.svg"/>,
      label: "대시보드",
    },
    component: loadable(() => import("../pages/dashboard/List")),
  },
  {
    exact: true,
    path: "/user",
    sidebar: {
      icon: <UserOutlined />,
      label: "회원 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "회원 리스트",
        },
        component: loadable(() => import("../pages/user/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/user/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/partner",
    sidebar: {
      icon: <img src="/assets/icon/Partner.svg"/>,
      label: "파트너 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "파트너 관리",
        },
        component: loadable(() => import("../pages/partner/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/register/:type",
        component: loadable(() => import("../pages/partner/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/partner/Modify")),
      },
    ]
  },
  {
    exact: true,
    path: "/product",
    sidebar: {
      icon: <CarOutlined/>,
      label: "상품 관리",
    },
    children: [
      {
        exact: true,
        path: "/group",
        sidebar: {
          label: "그룹 리스트",
        },
        component: loadable(() => import("../pages/product/group/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/group/register",
        component: loadable(() => import("../pages/product/group/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/group/detail/:id",
        component: loadable(() => import("../pages/product/group/Modify")),
      },
      {
        exact: true,
        path: "/model",
        sidebar: {
          label: "모델 리스트",
        },
        component: loadable(() => import("../pages/product/model/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/model/register",
        component: loadable(() => import("../pages/product/model/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/model/detail/:id",
        component: loadable(() => import("../pages/product/model/Modify")),
      },
      {
        exact: true,
        path: "",
        sidebar: {
          label: "상품 리스트",
        },
        component: loadable(() => import("../pages/product/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/register",
        component: loadable(() => import("../pages/product/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/product/Modify")),
      },
      {
        exact: true,
        path: "/erp",
        sidebar: {
          label: "ERP 맵핑",
        },
        component: loadable(() => import("../pages/product/erp/List")),
      },
      {
        exact: true,
        path: "/add/category",
        sidebar: {
          label: "부가 상품 리스트",
        },
        component: loadable(() => import("../pages/product/add/CategoryList")),
      },
      {
        exact: true,
        visible: false,
        path: "/add/product/:id",
        component: loadable(() => import("../pages/product/add/List")),
      }
    ]
  },
  {
    exact: true,
    path: "/insurance",
    sidebar: {
      icon: <img src="/assets/icon/Insurance.svg"/>,
      label: "보험 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "보험 리스트",
        },
        component: loadable(() => import("../pages/insurance/List")),
      },
    ],
  },
  {
    exact: true,
    path: "/coupon",
    sidebar: {
      icon: <img src="/assets/icon/Coupon.svg"/>,
      label: "쿠폰 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "쿠폰 리스트",
        },
        component: loadable(() => import("../pages/coupon/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/rentcarhub/register",
        component: loadable(() => import("../pages/coupon/rentcarhub/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/rentcarhub/detail/:id",
        component: loadable(() => import("../pages/coupon/rentcarhub/Modify")),
      },
      {
        exact: true,
        visible: false,
        path: "/company/register",
        component: loadable(() => import("../pages/coupon/company/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/company/detail/:id",
        component: loadable(() => import("../pages/coupon/company/Modify")),
      },
      {
        exact: true,
        path: "/history",
        sidebar: {
          label: "쿠폰 지급내역",
        },
        component: loadable(() => import("../pages/coupon/history/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/history/detail/:id",
        component: loadable(() => import("../pages/coupon/history/Detail")),
      },
    ]
  },
  {
    exact: true,
    path: "/review",
    sidebar: {
      icon: <MessageOutlined />,
      label: "리뷰 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "리뷰 리스트",
        },
        component: loadable(() => import("../pages/review/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/review/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/point",
    sidebar: {
      icon: <img src="/assets/icon/Point.svg"/>,
      label: "포인트 관리",
    },
    children: [
      {
        exact: true,
        path: "/setting",
        sidebar: {
          label: "포인트 지급 설정",
        },
        component: loadable(() => import("../pages/point/Setting")),
      },
      {
        exact: true,
        path: "",
        sidebar: {
          label: "포인트 지급/차감 내역",
        },
        component: loadable(() => import("../pages/point/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/point/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/reservation",
    sidebar: {
      icon: <img src="/assets/icon/Reservation.svg"/>,
      label: "예약 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "예약 내역 리스트",
        },
        component: loadable(() => import("../pages/reservation/List")),
      },
      {
        exact: true,
        path: "/cancel",
        sidebar: {
          label: "예약 취소신청 리스트",
        },
        component: loadable(() => import("../pages/reservation/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/reservation/Detail")),
      },
      {
        exact: true,
        visible: false,
        path: "/register",
        component: loadable(() => import("../pages/reservation/Register")),
      },
    ],
  },
  {
    exact: true,
    path: "/calculate",
    sidebar: {
      icon: <img src="/assets/icon/Calculate.svg"/>,
      label: "정산 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "정산 리스트",
        },
        component: loadable(() => import("../pages/calculate/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/calculate/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/contents",
    sidebar: {
      icon: <BookOutlined />,
      label: "컨텐츠 관리",
    },
    children: [
      {
        exact: true,
        path: "/notice",
        sidebar: {
          label: "공지사항 관리",
        },
        component: loadable(() => import("../pages/contents/notice/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/notice/register",
        component: loadable(() => import("../pages/contents/notice/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/notice/detail/:id",
        component: loadable(() => import("../pages/contents/notice/Modify")),
      },
      {
        exact: true,
        path: "/event",
        sidebar: {
          label: "이벤트 관리",
        },
        component: loadable(() => import("../pages/contents/event/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/event/register",
        component: loadable(() => import("../pages/contents/event/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/event/detail/:id",
        component: loadable(() => import("../pages/contents/event/Modify")),
      },
      {
        exact: true,
        path: "/popup",
        sidebar: {
          label: "팝업 관리",
        },
        component: loadable(() => import("../pages/contents/popup/List")),
      },
    ],
  },
  {
    exact: true,
    path: "/alarm",
    sidebar: {
      icon: <BellOutlined />,
      label: "알림 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "알림 발송",
        },
        component: loadable(() => import("../pages/alarm/Register")),
      },
      {
        exact: true,
        path: "/history",
        sidebar: {
          label: "알림 발송내역",
        },
        component: loadable(() => import("../pages/alarm/List")),
      },
      {
        exact: true,
        path: "/alarm/variable",
        sidebar: {
          label: "알림톡 변수 관리",
        },
        component: loadable(() => import("../pages/alarm/variable/List")),
      },
      {
        exact: true,
        path: "/template",
        sidebar: {
          label: "알림톡 템플릿 관리",
        },
        component: loadable(() => import("../pages/alarm/template/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/template/register",
        component: loadable(() => import("../pages/alarm/template/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/template/detail/:id",
        component: loadable(() => import("../pages/alarm/template/Detail")),
      },
    ]
  },
  {
    exact: true,
    path: "/cs",
    sidebar: {
      icon: <CustomerServiceOutlined />,
      label: "고객센터 관리",
    },
    children: [
      {
        exact: true,
        path: "/faq/category",
        sidebar: {
          label: "자주 묻는 질문",
        },
        component: loadable(() => import("../pages/cs/faq/CategoryList")),
      },
      {
        exact: true,
        visible: false,
        path: "/faq/:id",
        component: loadable(() => import("../pages/cs/faq/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/faq/register/:id",
        component: loadable(() => import("../pages/cs/faq/Register")),
      },
      {
        exact: true,
        visible: false,
        path: "/faq/detail/:id",
        component: loadable(() => import("../pages/cs/faq/Detail")),
      },
      {
        exact: true,
        path: "/report",
        sidebar: {
          label: "신고 리스트",
        },
        component: loadable(() => import("../pages/cs/report/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/report/detail/:id",
        component: loadable(() => import("../pages/cs/report/Detail")),
      },
    ]
  },
  {
    exact: true,
    path: "/etc",
    sidebar: {
      icon: <img src="/assets/icon/Etc.svg"/>,
      label: "기타 관리",
    },
    children: [
      {
        exact: true,
        path: "/term",
        sidebar: {
          label: "약관 관리",
        },
        component: loadable(() => import("../pages/etc/term/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/term/history/:type",
        component: loadable(() => import("../pages/etc/term/HistoryList")),
      },
      {
        exact: true,
        path: "/information",
        sidebar: {
          label: "운영 정책 관리",
        },
        component: loadable(() => import("../pages/etc/information/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/information/history/:type",
        component: loadable(() => import("../pages/etc/information/HistoryList")),
      },
      {
        exact: true,
        path: "/cancel/setting",
        sidebar: {
          label: "환불 수수료 관리",
        },
        component: loadable(() => import("../pages/etc/cancelSetting/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/cancel/setting/history",
        component: loadable(() => import("../pages/etc/cancelSetting/HistoryList")),
      },
      {
        exact: true,
        path: "/api",
        sidebar: {
          label: "API KEY 관리",
        },
        component: loadable(() => import("../pages/etc/api/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/api/history",
        component: loadable(() => import("../pages/etc/api/History")),
      },
      {
        exact: true,
        path: "/data",
        sidebar: {
          label: "데이터 관리",
        },
        component: loadable(() => import("../pages/etc/data/List")),
      },
      {
        exact: true,
        path: "/main",
        sidebar: {
          label: "메인 홈 관리",
        },
        component: loadable(() => import("../pages/etc/main/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/main/modify/:id",
        component: loadable(() => import("../pages/etc/main/Modify")),
      },
      {
        exact: true,
        visible: false,
        path: "/main/register",
        component: loadable(() => import("../pages/etc/main/Register")),
      },
      {
        exact: true,
        path: "/carYear",
        sidebar: {
          label: "차량 연식 관리",
        },
        component: loadable(() => import("../pages/etc/carYear/List")),
      },
    ]
  },
  {
    exact: true,
    path: "/stats",
    sidebar: {
      icon: <img src="/assets/icon/Stats.svg"/>,
      label: "매출/통계",
    },
    children: [
      {
        exact: true,
        path: "/rent/:type",
        sidebar: {
          label: "렌터카사",
        },
        component: loadable(() => import("../pages/stats/rent/List")),
      },
      {
        exact: true,
        path: "/addProduct/:type",
        sidebar: {
          label: "부가서비스",
        },
        component: loadable(() => import("../pages/stats/addProduct/List")),
      },
      {
        exact: true,
        path: "/user",
        sidebar: {
          label: "회원",
        },
        component: loadable(() => import("../pages/stats/user/List")),
      },
      {
        exact: true,
        path: "/group/:type",
        sidebar: {
          label: "차종",
        },
        component: loadable(() => import("../pages/stats/group/List")),
      },
      {
        exact: true,
        path: "/model/:type",
        sidebar: {
          label: "차량",
        },
        component: loadable(() => import("../pages/stats/model/List")),
      },
    ],
  },
    /*
  {
    exact: true,
    path: "/stats",
    sidebar: {
      icon: <img src="/assets/icon/Stats.svg"/>,
      label: "매출/통계",
    },
    children: [
      {
        exact: true,
        path: "/rent/:type",
        sidebar: {
          label: "렌터카사",
        },
        component: loadable(() => import("../pages/stats/rent/List")),
      },
      {
        exact: true,
        path: "/add/:type",
        sidebar: {
          label: "부가 서비스",
        },
        component: loadable(() => import("../pages/stats/add/List")),
      },
      {
        exact: true,
        path: "/user",
        sidebar: {
          label: "회원",
        },
        component: loadable(() => import("../pages/stats/user/List")),
      },
      {
        exact: true,
        path: "/group/:type",
        sidebar: {
          label: "차종",
        },
        component: loadable(() => import("../pages/stats/group/List")),
      },
      {
        exact: true,
        path: "/model/:type",
        sidebar: {
          label: "차량",
        },
        component: loadable(() => import("../pages/stats/model/List")),
      },
    ],
  }*/
];
